module.exports = __webpack_public_path__ + "img/phone-body-null.65a14018.png";